import { useContext } from 'react'

import PrimaryBannerPreviewContext from 'contexts/PrimaryBannerPreviewContext'

const usePrimaryBannerPreview = () => {
  const context = useContext(PrimaryBannerPreviewContext)

  if (context === undefined) {
    throw new Error(
      'usePrimaryBannerPreview must be used within a PrimaryBannerPreviewContext.Provider',
    )
  }

  return {
    size: context.size,
    isCompact: context.isCompact,
    isMobile: context.isMobile,
    previewTexts: context.previewTexts,
    descriptionRef: context.descriptionRef,
    isDescriptionExpanded: context.isDescriptionExpanded,
    isDescriptionOverflowing: context.isDescriptionOverflowing,
    showDescriptionToggle: context.showDescriptionToggle,
    onToggleDescription: context.onToggleDescription,
    privacyPortalEnabled: context.privacyPortalEnabled,
    privacyPortalUrl: context.privacyPortalUrl,
    onManageCookies: context.onManageCookies,
    handleOpenBanner: context.handleOpenBanner,
    hideRejectButton: context.hideRejectButton,
  }
}

export default usePrimaryBannerPreview
